import { useEffect, useRef } from "react";
import Hls from "hls.js";
import "./videoplayer.scss";

export default function VideoPlayer({ url, isLive = true, cameraName }) {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current || !url) return;

    if (Hls.isSupported()) {
      const hls = new Hls({
        liveSyncDuration: isLive ? 3 : undefined, // 🔴 fast sync for live
        liveMaxLatencyDuration: isLive ? 10 : undefined, // max buffer behind live edge
        enableWorker: true,
        lowLatencyMode: isLive,
        debug: false,
      });

      hls.loadSource(url);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("HLS manifest loaded, ready to play");
        videoRef.current.play();
      });

      // save reference to cleanup
      hlsRef.current = hls;
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari native support
      videoRef.current.src = url;
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [url, isLive]);

  return (
    <video
      ref={videoRef}
      autoPlay
      controls
      muted
      width="640"
      height="360"
      className="live-video-player"
      style={{ backgroundColor: "black" }}
      aria-label={`Live streaming from ${cameraName}`}
    />
  );
}
